import React from 'react'

 const FraemIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20.85" height="14.695" viewBox="0 0 20.85 14.695">
  <g id="noun-location-1254018" transform="translate(-114.802 -280)">
    <path id="Path_7526" data-name="Path 7526" d="M116.919,280l3.832,7.13,2.35-2.939,3.361-.517L124.823,280h-7.9Zm9.063,0,1.736,3.674h6.815L134.161,280Zm-9.792.987L114.8,294.695h8.757Zm18.459,3.723h-6.488l2.185,4.107h4.708Zm-7.757.106c-.015.048-3.277.658-3.293.607l-2.235,2.842,3.459,6.429h7.423Zm8.263,4.976h-4.367l2.723,4.9h2.141l-.5-4.9Z" transform="translate(0)" />
  </g>
</svg>

  );
};
export default FraemIcon
